
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vaerktoejer",
      function () {
        return require("private-next-pages/vaerktoejer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vaerktoejer"])
      });
    }
  